import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const PublicLayout = ({ children }) => (
  <div className="App min-h-screen bg-[#0D0D0D]">
    <Navbar />
    <main>{children}</main>
    <Footer />
  </div>
);

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="relative overflow-hidden pt-[132px] pb-16">
    <div className="pointer-events-none absolute top-[60px] left-1/2 -translate-x-1/2 w-[800px] h-[420px] rounded-full"
      style={{ background: "radial-gradient(ellipse at center, rgba(255,92,0,0.12) 0%, transparent 65%)" }} />
    <div className="relative max-w-[820px] mx-auto px-6 text-center">
      {eyebrow && <p className="text-[13px] font-semibold tracking-[0.18em] uppercase text-[#FF5C00]">{eyebrow}</p>}
      <h1 className="mt-4 text-[40px] md:text-[54px] font-extrabold tracking-tight text-white leading-[1.05]">{title}</h1>
      {subtitle && <p className="mt-5 text-[18px] leading-relaxed text-neutral-400 max-w-[620px] mx-auto">{subtitle}</p>}
    </div>
  </section>
);

export default PublicLayout;
